/**
 * Convierte cualquier cadena en un slug URL-friendly.
 * Reglas aplicadas (en orden):
 *  1. trim() — elimina espacios al inicio/final
 *  2. toLowerCase() — fuerza minúsculas (evita URLs con mayúsculas)
 *  3. normalize('NFD') + strip diacríticos — elimina tildes y acentos
 *  4. Reemplaza espacios y guiones bajos por guiones
 *  5. Elimina caracteres no alfanuméricos (excepto guiones)
 *  6. Colapsa guiones múltiples consecutivos en uno solo
 *  7. Elimina guiones al inicio y al final
 */
export const getProductSlug = (name: string): string => {
  return name
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-{2,}/g, '-')
    .replace(/^-+|-+$/g, '');
};

/**
 * Convierte un nombre de bundle/pack en un slug URL-friendly.
 * Usa la misma lógica que getProductSlug para consistencia.
 */
export const getBundleSlug = (name: string): string => {
  return getProductSlug(name);
};

/**
 * Normaliza una URL de path interno:
 *  - Fuerza minúsculas
 *  - Elimina query params y hash
 *  - Elimina trailing slash (excepto raíz "/")
 *  - Colapsa barras dobles
 */
export const normalizeInternalPath = (path: string): string => {
  const clean = path
    .split('?')[0]
    .split('#')[0]
    .toLowerCase()
    .replace(/\/+/g, '/')
    .replace(/\/$/, '') || '/';
  return clean;
};
